import { inject, Injectable } from '@angular/core';
import { ViewModel, APIParameterModel, FormDataModel } from '../event.model';
import { parseImageDataForBE } from '@app/user-content/user-input-v2/utils/image-data-utils';
import { parseOwnerDataForBE } from '@app/user-content/user-input-v2/utils/content-owner-helper';
import { ImageUrlService } from '@app/user-content/user-input/services/image-url.service';
import { parseSessionDataForBE } from '@app/user-content/user-input-v2/utils/session-utils';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { parseAdvancedDataForBE } from '@app/user-content/user-input-v2/utils/advanced-data-utils';

@Injectable({ providedIn: 'root' })
export class EventMapper {
  private imageUrlService = inject(ImageUrlService);
  private dateHandler = inject(NgbDateParserFormatter);

  /**
   * Convert the view model and form model to API parameters
   *
   * Please only pass the properties that are needed for the API call.
   * In some places we're dumping the entire view model into the API call
   * and that makes it very difficult to identify what properties are actually needed.
   */
  public buildApiParameters(
    viewModel: ViewModel,
    formModel: FormDataModel
  ): APIParameterModel {
    const {
      addToCatalog,
      eventUrl,
      skills,
      summary,
      title,
      sessionDetails,
      owner,
    } = formModel;

    const { durationMinutes, durationHours } = formModel.durationForm;

    const {
      fileManaged,
      inputId,
      inputType,
      isSessionDetailsToggledOn,
      organizationId,
      sessionLocation,
    } = viewModel;

    return {
      addToCatalog,
      durationHours,
      durationMinutes,
      eventUrl,
      fileManaged,
      inputId,
      inputType,
      name: title,
      organizationId,
      obsolete: false,
      sessions: parseSessionDataForBE(
        sessionDetails,
        sessionLocation,
        isSessionDetailsToggledOn,
        this.dateHandler
      ),
      summary,
      tags: skills,
      ...parseAdvancedDataForBE(formModel.advancedSettings),
      ...parseImageDataForBE(viewModel, this.imageUrlService),
      ...parseOwnerDataForBE(owner),
    };
  }
}
